import React, { useEffect } from 'react'

import { TopbarProps } from './Topbar.types'
import TopbarDesktop from './Desktop/TopbarDesktop.index'
import TopbarMobile from './Mobile/TopbarMobile.index'

let lastKnowScrollPosition = 0

let FIXED_POSITION_OFFSET_DESKTOP = 190
let FIXED_POSITION_OFFSET_MOBILE = 60
let delayFixedPosition = false
let delayFixedPositionTimeoutId: NodeJS.Timeout

let lastScrollTop = 0
let scrollDirection : string | null = null

let isTopbarFixed = false
let isTopbarVisible = true

let SCREEN_WIDTH_DESKTOP = 1016
let DELAY_MS_TO_FIXED_TOPBAR = 100

let enabledHeader = false

const UP = 'UP'
const DOWN = 'DOWN'

const handleScrollEvent = (event: Event) => {
  let initialScrollPosition = window.scrollY || document.documentElement.scrollTop

  lastKnowScrollPosition = initialScrollPosition - lastKnowScrollPosition
  lastKnowScrollPosition = lastKnowScrollPosition <= 0 ? 0 : lastKnowScrollPosition

  let scrollOffset = lastScrollTop - initialScrollPosition
  scrollDirection = scrollOffset < 0 ? DOWN : scrollOffset > 0 ? UP : null
  lastScrollTop = initialScrollPosition <= 0 ? 0 : initialScrollPosition

  const screenOffset = screen.width < SCREEN_WIDTH_DESKTOP ? FIXED_POSITION_OFFSET_MOBILE : FIXED_POSITION_OFFSET_DESKTOP

  // Menor scroll possível, garantindo que o topbar não fique fixo
  if (!lastScrollTop){
    delayFixedPosition = false

    isTopbarFixed = false
    isTopbarVisible = true
  }

  if (!delayFixedPosition) {
    delayFixedPosition = true

    if (lastKnowScrollPosition > screenOffset && !isTopbarFixed) {
      isTopbarFixed = true
    }

    if (lastKnowScrollPosition <= screenOffset) {
      isTopbarFixed = false
      isTopbarVisible = true
    }

    if (delayFixedPositionTimeoutId) clearTimeout(delayFixedPositionTimeoutId)
    delayFixedPositionTimeoutId = setTimeout(() => {
      if (typeof delayFixedPosition !== 'undefined') delayFixedPosition = false
    }, DELAY_MS_TO_FIXED_TOPBAR)
  }
  //#end delayFixedPosition

  if (
    initialScrollPosition > lastKnowScrollPosition &&
    isTopbarFixed
  ) {
    isTopbarVisible = false
  }

  if (
    scrollDirection === UP &&
    !isTopbarVisible &&
    isTopbarFixed
  ) {
    isTopbarVisible = true
  }

  event?.preventDefault()

  let topbarHeader = document.getElementById('topbar-header')
  let topbarWrapper = document.getElementById('topbar-wrapper')

  if (!isTopbarFixed)  {
    topbarHeader?.classList.remove('topbar-fixed')
    topbarWrapper?.classList.remove('topbar-fixed')
  } else {
    topbarHeader?.classList.add('topbar-fixed')
    topbarWrapper?.classList.add('topbar-fixed')
  }

  if (!isTopbarVisible) {
    topbarWrapper?.classList.add('topbar-hidden')
    topbarWrapper?.classList.remove('topbar-visible')
  } else {
    topbarWrapper?.classList.add('topbar-visible')
    topbarWrapper?.classList.remove('topbar-hidden')
  }
}

const Topbar: React.FC<TopbarProps> = ({ topbarDesktop, topbarMobile }) => {

  useEffect(() => {
    if (!enabledHeader) {
      enabledHeader = true
      document.addEventListener('scroll', (event) => {
        handleScrollEvent(event)
      })
    }
  }, [])

  return (
    <React.Fragment>
      <div id="topbar-header" className="topbar topbar-fixed">
        <div id="topbar-wrapper" className="pivot topbar-visible">
          <TopbarMobile {...topbarMobile} />
          <TopbarDesktop {...topbarDesktop} />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Topbar